/* global XMLHttpRequest */
import appConfig from 'app/config/client';
import createErrorType from 'app/utils/createErrorType';

export class FluentdNetworkError extends createErrorType('FluentdNetworkError') {}

export default function sendPayloadToFluentd(payloadString, { onError, onSuccess } = {}) {
  try {
    const request = new XMLHttpRequest();
    request.open('POST', appConfig.fluentd.endpoint, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('Accept', 'text/json, application/json');
    request.addEventListener('error', () => {
      onError && onError(new FluentdNetworkError('Fluentd error payload failed to send.'));
    });
    request.addEventListener('load', () => {
      if (request.status !== 200) {
        onError && onError(new Error(
          `Expected 200 response from fluentd, but got ${request.status} status.`,
        ));
      } else {
        onSuccess && onSuccess();
      }
    });

    request.send(payloadString);
  } catch (e) {
    // If sending the payload fails at the last step, don't throw an error, or else it could be
    // caught be the global onerror handler and we could cause an infinite loop.
    onError && onError(e);
  }
}
